import { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronDown, ChevronRight, AlertTriangle } from 'lucide-react';
import { API_URL } from '../../lib/api';
import { eur } from './api';

// Lecture seule : dépenses déjà comptabilisées du mois de la facture, montants proches en tête
export function MonthExpenses({ mois, ttc, ht }) {
    const [data, setData] = useState(null);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!/^\d{4}-\d{2}$/.test(mois || '')) { setData(null); return; }
        const t = setTimeout(() => axios.get(`${API_URL}/api/invoice-review/depenses-mois`, { withCredentials: true, params: { mois, ttc: ttc || undefined, ht: ht || undefined } })
            .then(r => { setData(r.data); if (r.data.nb_proches) setOpen(true); }).catch(() => setData(null)), 300);
        return () => clearTimeout(t);
    }, [mois, ttc, ht]);
    if (!data) return null;
    return (
        <div className={`rounded-xl border ${data.nb_proches ? 'border-amber-300 bg-amber-50/60' : 'border-gray-200 bg-white'}`} data-testid="month-expenses">
            <button onClick={() => setOpen(o => !o)} className="w-full flex items-center gap-2 px-3 py-2 text-[12px] text-left" data-testid="month-expenses-toggle">
                {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
                <span className="font-medium text-gray-700">Dépenses déjà comptabilisées en {mois} ({data.items.length})</span>
                {data.nb_proches > 0 && <span className="ml-auto flex items-center gap-1 text-amber-700 font-medium" data-testid="month-expenses-near"><AlertTriangle className="w-3.5 h-3.5" />{data.nb_proches} montant(s) proche(s)</span>}
            </button>
            {open && (
                <ul className="max-h-56 overflow-auto border-t border-gray-100 divide-y divide-gray-100" data-testid="month-expenses-list">
                    {!data.items.length && <li className="px-3 py-2 text-[12px] text-gray-400">Aucune dépense enregistrée ce mois</li>}
                    {data.items.map((x, i) => (
                        <li key={i} className={`px-3 py-1.5 text-[12px] flex gap-2 ${x.proche ? 'bg-amber-100/60' : ''}`} data-testid={`month-expense-${i}`}>
                            <span className="w-28 shrink-0 text-gray-400">{x.source}</span>
                            <span className="flex-1 min-w-0 truncate text-gray-700">{x.fournisseur ? `${x.fournisseur} · ` : ''}{x.libelle}{x.numero ? ` · n° ${x.numero}` : ''}</span>
                            <span className="text-gray-400 shrink-0">{x.date}</span>
                            <span className={`font-mono shrink-0 ${x.proche ? 'text-amber-800 font-semibold' : 'text-gray-700'}`}>{eur(x.montant)}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
